import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DataTable from 'base/components/table/DataTable/index';
import MainTitle from 'base/components/MainTitle/index';
import Header from 'base/components/Header/index';
import { AppsIcon, AddIcon } from 'base/components/Icon/index';
import { setActiveRoleId, fetchAllRoles } from 'auth/store/roles/actions';
import { getAllRoles } from 'auth/store/roles/selectors';
import theme from 'theme/theme';
import Button from 'base/components/Button/index';
import ButtonGroup from 'base/components/ButtonGroup/index';
import {
  getDeleteColumn,
  getEditColumn,
  getPermissionColumn,
} from 'base/components/table/RowActionButton';
import withGlobalFilter from 'base/components/table/withGlobalFilter';
import { openModal } from '../../../modal';

const FilteredTable = withGlobalFilter(DataTable);

class ManageRoles extends React.Component {
  componentDidMount() {
    const { fetchAll } = this.props;
    fetchAll();
  }

  handleEdit = (data) => {
    const { setActiveRoleId, openModal } = this.props;
    setActiveRoleId(data.id);
    openModal('ROLE_EDIT');
  };

  handleDelete = (data) => {
    const { setActiveRoleId, openModal } = this.props;
    setActiveRoleId(data.id);
    openModal('ROLE_DELETE');
  };

  render() {
    const { roles, openModal } = this.props;

    const columns = [
      {
        Header: 'Name',
        accessor: 'name',
        showOnMobile: true,
      },
      getPermissionColumn(),
      getEditColumn(this.handleEdit),
      getDeleteColumn(this.handleDelete),
    ];

    return (
      <>
        <Header>
          <MainTitle>
            <AppsIcon />
            {' '}
Manage Roles
          </MainTitle>
          <ButtonGroup pullRight>
            <Button onClick={() => openModal('ROLE_CREATE')}>
              <AddIcon color={theme.colors.medium} />
              {' '}
New role
            </Button>
          </ButtonGroup>
        </Header>
        <FilteredTable
          data={roles}
          columns={columns}
          defaultSorted={[{
            id: 'name',
            desc: false,
          }]}
          filterKeys={['name']}
          filterLabel="Filter by name..."
        />
      </>
    );
  }
}
ManageRoles.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAll: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  setActiveRoleId: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => ({
  roles: getAllRoles(state),
});

const mapDispatchToProps = {
  fetchAll: fetchAllRoles,
  openModal,
  setActiveRoleId,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageRoles);
